import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import { IJourney } from '@transferz/fe-models';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useQueryJourneysByBookingCode } from '../../queries/booking/hooks/useQueryJourneysByBookingCode';

const AutoLogin: React.FC<any> = ({ params: { bookingOrJourneyCode, lastName } }) => {
  const [, setValue] = useLocalStorage('userIdentity');
  const [, setLocation] = useLocation();
  setValue('userIdentity', decodeURIComponent(lastName));
  const urlParams = new URLSearchParams(window.location.search);
  const phoneNumberVerified = urlParams.get('phone-number-verified');
  const token = urlParams.get('token');

  const isJourneyCode = bookingOrJourneyCode.includes('-');
  let bookingCode: string;

  if (isJourneyCode) {
    bookingCode = bookingOrJourneyCode.split('-')[0];
  } else {
    bookingCode = bookingOrJourneyCode;
  }

  const { data } = useQueryJourneysByBookingCode({ variables: { bookingCode } });

  useEffect(() => {
    if (data?.journeysByBookingCode?.results) {
      const queryParams = (phoneNumberVerified && token)
        ? `?${urlParams.toString()}`
        : '';
      if (isJourneyCode) {
        const matchedJourney = data.journeysByBookingCode.results
          .filter((journey: IJourney) => journey.journeyCode === bookingOrJourneyCode)[0];

        setLocation(`/booking/${bookingCode}/journey/${matchedJourney.id}${queryParams}`, { replace: true });
      } else {
        if (data.journeysByBookingCode.results.length === 1) {
          setLocation(`/booking/${bookingCode}/journey/${data.journeysByBookingCode.results[0].id}${queryParams}`, { replace: true });
        } else {
          setLocation(`/booking/${bookingCode}${queryParams}`, { replace: true });
        }
      }

    }
  }, [data]);

  return null;
};

export default AutoLogin;
